import { render } from "./Category.vue?vue&type=template&id=2e53b422&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=2e53b422&scoped=true&lang=scss"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e53b422"]])

export default __exports__